import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';
import ImportExportIcon from '@material-ui/icons/ImportExport';

import {
  PERMISSAO_TELA_MALOTES_LISTAR,
  PERMISSAO_TELA_SUBMALOTES_LISTAR,
  PERMISSAO_TELA_SANGRIAS_LISTAR,
  PERMISSAO_TELA_TROCOS_LISTAR,
  PERMISSAO_TELA_SOBRAS_LISTAR,
  PERMISSAO_TELA_SINISTROS_LISTAR,
  PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR,
  PERMISSAO_TELA_LIXEIRA_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuMalote = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Malotes"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_MALOTES_LISTAR] && hasResource('malote_malotes')}
    {permissoes[PERMISSAO_TELA_SUBMALOTES_LISTAR] &&
      hasResource('malote_submalotes')}
    {permissoes[PERMISSAO_TELA_SANGRIAS_LISTAR] &&
      hasResource('malote_sangrias')}
    {permissoes[PERMISSAO_TELA_TROCOS_LISTAR] && hasResource('malote_trocos')}
    {permissoes[PERMISSAO_TELA_SOBRAS_LISTAR] && hasResource('malote_sobras')}
    {permissoes[PERMISSAO_TELA_SINISTROS_LISTAR] &&
      hasResource('malote_sinistros')}
    {permissoes[PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR] && (
      <StyledMenuItemLink
        key="conta-gerencial"
        to="/conta-gerencial"
        primaryText="Conta Gerencial"
        leftIcon={<ImportExportIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_LIXEIRA_LISTAR] &&
      hasResource('lixeira_malotes')}
  </SubMenu>
);

export default SubMenuMalote;
